import i18next from 'i18next';

export default function initI18n() {
  i18next.addResourceBundle('en', 'execution-ui', {
    deleteSelectedExecutions: 'Delete selected executions',
    resumeExecution: 'Resume execution',
    pauseExecution: 'Pause execution',
    stopExecution: 'Stop execution',
    rerunExecution: 'Rerun execution',
    deleteExecution: 'Delete execution',

    couldNotGetInngestEvent: 'Could not get Inngest event from job result',
    rerunExecutionConfirmTitle: 'Rerun Execution',
    rerunExecutionConfirmDescription: 'Are you sure you want to rerun the execution?',
    executionDeleted: 'Execution deleted',
    executionsDeleted: '{{count}} execution deleted',
    executionsDeleted_plural: '{{count}} executions deleted',
    executionStopSignalSent: 'Execution stop signal sent',
    executionPauseSignalSent: 'Execution pause signal sent',
    executionResumeSignalSent: 'Execution resume signal sent',

    // Generic actions / nouns (reused across confirm dialogs)
    delete: 'Delete',
    execution: 'Execution',
    executions: 'Executions',
  });
}
